export enum PANE_LAYER {
  floatPane = 'floatPane',
  overlayMouseTarget = 'overlayMouseTarget',
}

export enum GOOGLE_RESPONSE_STATUS {
  OK = 'OK',
}
